export default {
   // baseURL: "https://api-sidu.parkatkrsintang.id/",
   baseURL: process.env.VUE_APP_BASE_URL,

   AppKey: "2396667391",
   AppPort: "1811",
};
